<p>
  edit-recurrent-shift-footer works!
</p>
